import { gql } from '@apollo/client';

export const GET_TASKS = gql`
  query tasks($first: Int, $page: Int) {
    tasks(first: $first, page: $page) {
      data {
        id
        title
        assigned_to {
          id
          login
          first_name
          last_name
        }
        deadline_at
        finished_at
      }
    }
  }
`;

export const CREATE_TASK = gql`
  mutation createWorkerTask($input: WorkerTaskInput!) {
    createWorkerTask(input: $input) {
      id
    }
  }
`;

export const UPDATE_TASK = gql`
  mutation updateWorkerTask($id: Int!, $input: WorkerTaskInput!) {
    updateWorkerTask(id: $id, input: $input) {
      id
    }
  }
`;

export const DELETE_TASK = gql`
  mutation deleteWorkerTask($id: Int!) {
    deleteWorkerTask(id: $id) {
      id
    }
  }
`;

export const SET_TASK_COMPLETED = gql`
  mutation setWorkerTaskComplete($id: Int!, $value: Boolean!) {
    setWorkerTaskComplete(id: $id, value: $value) {
      id
    }
  }
`;
